
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wunschliste",
      function () {
        return require("private-next-pages/wunschliste.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wunschliste"])
      });
    }
  